import { useReducer, useEffect } from "react";
import { LoadingEnum } from "../../../types/utility/async.js";
const initialState = {
  data: null,
  loading: LoadingEnum.Idle
};
function reducer(state, action) {
  switch (action.type) {
    case "loading":
      return { ...state, loading: action.data };
    case "data":
      return { ...state, data: action.data };
    case "error":
      return { ...state, error: action.data };
    default:
      throw new Error(`Неизвестный тип '${action.type}'`);
  }
}
function callFunction(fn, params) {
  if (fn && typeof fn === "function") {
    fn(...params);
  }
}
function useAsync(fn, options, deps = []) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { loading, data, error } = state;
  const { successCallback, errorCallback } = options || {};
  const dependencyList = Array.isArray(deps) ? deps : [];
  const execute = async (didCancel) => {
    try {
      if (!loading) {
        dispatch({ type: "loading", data: true });
      }
      const response = await fn();
      if (!didCancel) {
        dispatch({ type: "data", data: response });
        dispatch({ type: "error", data: null });
        callFunction(successCallback, [response]);
      }
    } catch (err) {
      if (!didCancel) {
        dispatch({ type: "error", data: err });
        callFunction(errorCallback, [err]);
      }
    } finally {
      if (!didCancel) {
        dispatch({ type: "loading", data: false });
      }
    }
  };
  useEffect(() => {
    let didCancel = false;
    execute(didCancel);
    return () => {
      didCancel = true;
    };
  }, dependencyList);
  return [data, loading, error, execute];
}
export {
  useAsync
};
